import type { Step3ExtractFeaturesResponse } from "@/chargeDetection/types"

export interface Step3ExtractFeaturesResultsProps {
  data: Step3ExtractFeaturesResponse
}

export function Step3ExtractFeaturesResults({ data }: Step3ExtractFeaturesResultsProps) {
  return <div>Extracted {data.feature_count} features</div>
}